const flatpickrUtil = {

    prefix: "",
    time: true,

    openPickrTime(prefix, id, val, time=true, maxDate="31.12.2036") {

        this.prefix = prefix
        this.time = time
        flatpickr("#" + this.prefix + "-datetimepicker-" + id, {
            enableTime: true,
            dateFormat: this.time ? "y-m-d\Th:i:s" : "y-m-d",
            enableSeconds: this.time,
            maxDate: maxDate,
            locale: util.locale,
            val: false,
            defaultDate: $(`#${this.prefix}-${id}`).text() ? 
                new Date($(`#${this.prefix}-${id}`).text()) : null,
            onOpen: function(val) {
                this.calendarContainer.insertAdjacentHTML('afterBegin', 
                    flatpickrUtil.appendFlatpickrNullCheckboxToCalendarHeader(id, val));
                if(flatpickrUtil.isPreviousChecked(id)) {
                    flatpickrUtil.checkNullCheckbox(this, id)
                }
                if(!flatpickrUtil.time) {
                    flatpickrUtil.removeTime()
                }
            },
            onChange: function() {
                flatpickrUtil.uncheckNullCheckbox(id)
            },
            onClose: function(data, val) {
                if(flatpickrUtil.isCheckedNullCheckbox(id)) {
                    flatpickrUtil.clearCalendarAndResetCurrentValue(this, id)
                    return
                }
                if(!val && !data[0]) {
                    return
                }
                flatpickrUtil.setNewChoosenValue(id, data[0])
            }
        }).open();

    },

    
    resetFlatPickrDate(el) {
        var flatpickr = $(el)[0]._flatpickr
        flatpickr.setDate(null)
        flatpickrUtil.setMidnight(flatpickr)
    },


    appendFlatpickrNullCheckboxToCalendarHeader(id, val) {
        return `<div class="null-flatpickr-header">
            <b>
                <label class="calendar-null-label">
                    <input id="${this.prefix}-NullCheckbox-${id}" type="checkbox" 
                        ${$(`#${this.prefix}-${id}`).text() ? '' : 'checked'} 
                        value="${val = $(`#${this.prefix}-${id}`).text() ? true : false}"
                        onchange="flatpickrUtil.resetFlatPickrDate('#${this.prefix}-datetimepicker-${id}')"
                        class="calendar-null-class"
                    />&nbsp;&nbsp;Null
                </label>
            </b>
        <div>`
    },

    resetCalendar(flatpickrObject) {    
        flatpickrObject.clear()
        flatpickrObject.set("defaultDate", new Date())
        flatpickrUtil.setMidnight(flatpickrObject)
    },

    isPreviousChecked(id) {
        return $(`#${this.prefix}-NullCheckbox-${id}`)[0] && $(`#${this.prefix}-NullCheckbox-${id}`)[0].checked
    },

    checkNullCheckbox(flatpickrObject, id) {
        flatpickrUtil.resetCalendar(flatpickrObject)
        $(`#${this.prefix}-NullCheckbox-${id}`)[0].checked = true
    },

    uncheckNullCheckbox(id) {
        $(`#${this.prefix}-NullCheckbox-${id}`)[0].checked = false
    },


    clearCalendarAndResetCurrentValue(flatpickrObject, id) {
        $(`#${this.prefix}-${id}`).text('')
        flatpickrObject.clear()
    },

    setNewChoosenValue(id, val) {
        $(`#${this.prefix}-${id}`).text(
            moment(val).format(this.time ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD')
        )
    },

    isCheckedNullCheckbox(id) {
        return $(`#${this.prefix}-NullCheckbox-${id}`)[0].checked
    },

    setMidnight(flatpickrObject) {
        if(!this.time) {
            return
        }
        flatpickrObject.hourElement.value = 11
        flatpickrObject.minuteElement.value = 59
        flatpickrObject.secondElement.value = 59
        flatpickrObject.amPM.textContent = 'PM'
    },

    removeTime() {
        $(".flatpickr-time").empty()
    },

    maxDateTwoYearsFromNow() {
        var d = new Date()
        d.setFullYear(d.getFullYear() + 2)
        return d
    }
}
export default flatpickrUtil;